/**
 * Brand / vendor constants shared by the public site and the dashboard.
 *
 * OVACS is developed by Stirringapps. The "Developed by" credit
 * (components/common/DevelopedBy.jsx) links to STIRRINGAPPS_URL in a new tab.
 */
export const STIRRINGAPPS_NAME = 'Stirringapps'
export const STIRRINGAPPS_URL = 'https://stirringapps.com'
